/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { EditSmallIcon, TrashIcon } from '@dynamika-shared/ui/icons';
import { clinicalTrialInventorySchema } from './clinicalTrialInventoryColumnSchema';
import {
  ClinicalTrialInventoryBaseType,
} from '@dynamika-shared/types/clinicalTrialInventory';
import { TeamMember } from '@dynamika-shared/types/teamMember';
import { ClinicalTrialInventoryState } from '@restore/clinicalTrialInventory/clinicalTrialInventory.types';

export type ClinicalInventoryColumnsContext = {
  allTeamMembers: TeamMember[];
  clinicalTrialInventoryState: ClinicalTrialInventoryState;
};

export function getClinicalInventoryColumns<
  T extends ClinicalTrialInventoryBaseType,
  K extends keyof typeof clinicalTrialInventorySchema.specific,
>(
  type: K,
  actions: {
    edit: (task: T) => void;
    delete: (task: T) => void;
  },
  context: ClinicalInventoryColumnsContext,
  isPM: boolean
): ColumnType<T>[] {

  const commonColumns = clinicalTrialInventorySchema.common as ColumnType<any>[];
  const specificColumns =
    (clinicalTrialInventorySchema.specific[type]?.(context) ?? []) as ColumnType<any>[];

  const actionColumn: ColumnType<any> = {
    name: 'action',
    header: () => 'Action',
    getValue: row => (
      <div className='flex justify-end gap-1'>
        <EditSmallIcon
          className='cursor-pointer hover:text-dodgerBlue'
          width={24}
          height={24}
          onClick={() => actions.edit(row)}
        />
        <TrashIcon
          className='cursor-pointer hover:text-dodgerBlue'
          width={24}
          height={24}
          onClick={() => actions.delete(row)}
        />
      </div>
    ),
    alignToRight: true,
    cellClassName: 'min-w-[5.7rem]',
    thClassName: 'w-[10rem] z-10',
  };

  const columns: ColumnType<any>[] = [
    ...commonColumns,
    ...specificColumns,
  ];

  if (!isPM) {
    columns.push(actionColumn);
  }

  return columns as ColumnType<T>[];
}
